/* One controller for the shared panel; page adapters only locate triggers and the insertion point. */
(function () {
  if (window.BTMGiftPanel) { window.BTMGiftPanel.scan(document); return; }
  window.BTMGiftPanel = { scan };
  function activate(voucher) {
    if (voucher.dataset.gvReady === 'true') return;
    voucher.dataset.gvReady = 'true';
    const form = voucher.closest('form');
    const context = voucher.dataset.giftContext;
    const row = context === 'product' ? voucher.closest('[data-pgv-section]')
      : context === 'landing' ? document.getElementById(voucher.dataset.giftCardId)
      : voucher.closest('.game-row');
    if (!form || !row) return;
    const controls = context === 'product' ? 'pgv' : context === 'landing' ? 'lgv' : 'gv';
    const openBtns = context === 'product'
      ? [...document.querySelectorAll('[data-pgv-open]')].filter(button => button.dataset.pgvOwner === form.getAttribute('id'))
      : [...row.querySelectorAll('[data-' + controls + '-open]')];
    const openBtn = openBtns[0];
    if (!openBtn) return;
    const directBtns = [...document.querySelectorAll('[data-' + controls + '-direct]')].filter(button => button.form === form);
    const priceNodes = context === 'product'
      ? [...row.querySelectorAll('[data-pgv-base-price]'), ...document.querySelectorAll('#noir-product-sticky-' + row.dataset.pgvSection + ' [data-pgv-base-price]')]
      : [...row.querySelectorAll(context === 'landing' ? '[data-lgv-base-price]' : '[data-btm-price-owner]')];
    const slot = context === 'landing' ? form.closest('[data-lgv-slot]') : null;
    const grid = slot?.closest('[data-lgv-grid]');
    const panel = voucher.querySelector('[data-gv-panel]');
    const hiddenId = voucher.querySelector('[data-gv-variant-id]');
    const giftProperty = voucher.querySelector('[data-gv-property-gift]');
    const typeProperty = voucher.querySelector('[data-gv-property-type]');
    const add = voucher.querySelector('[data-gv-add]');
    const recipient = voucher.querySelector('[data-gv-name]');
    const nameWrap = voucher.querySelector('[data-gv-name-wrap]');
    const photo = voucher.querySelector('[data-gv-img]');
    const zoomBtn = voucher.querySelector('[data-gv-zoom]');
    const photoMissing = voucher.querySelector('[data-gv-missing]');
    const dialog = voucher.querySelector('[data-gv-dialog]');
    const dialogImg = voucher.querySelector('[data-gv-dialog-img]');
    const error = voucher.querySelector('[data-gv-error]');
    let variants, images;
    try {
      variants = JSON.parse(voucher.querySelector('[data-gv-data]').textContent);
      images = JSON.parse(voucher.querySelector('[data-gv-images]').textContent);
    } catch (exc) { console.error('BTM: invalid voucher JSON', exc); return; }
    let selected = voucher.dataset.gvDefault === 'printed' && variants.printed && variants.printed.available ? 'printed' : 'digital';
    let index = 0;
    let photoReady = false;
    const el = attr => voucher.querySelector('[data-gv-' + attr + ']');
    const currentPhotos = () => images[selected] || [];
    function errorMessage(msg) { error.textContent = msg; error.hidden = !msg; }
    function setPurchase(gift) {
      const key = gift ? selected : 'digital';
      const variant = variants[key];
      recipient.disabled = !gift || key !== 'digital';
      recipient.required = !recipient.disabled;
      if (!variant || !variant.available) { hiddenId.value = ''; return false; }
      hiddenId.value = variant.id;
      giftProperty.disabled = !gift;
      typeProperty.disabled = !gift;
      if (gift) typeProperty.value = key === 'printed' ? 'Tištěný' : 'Online PDF';
      return true;
    }
    function renderPhoto() {
      const all = currentPhotos();
      const data = all[index];
      const prev = el('prev'), next = el('next');
      prev.hidden = index === 0;
      next.hidden = index >= all.length - 1;
      el('arrows').hidden = all.length < 2;
      photoReady = false;
      zoomBtn.disabled = true;
      photoMissing.hidden = true;
      if (!data || !data.src) {
        photo.removeAttribute('src');
        photo.hidden = true;
        photoMissing.hidden = false;
        return;
      }
      // Keep each photograph's desktop and mobile crop independent.
      for (const key of ['pc_x', 'pc_y', 'mob_x', 'mob_y']) {
        const raw = data.position?.[key];
        const value = raw == null || raw === '' ? 50 : Number(raw);
        photo.style.setProperty('--gv-img-' + key.replace('_', '-'),
          (Number.isFinite(value) ? Math.max(0, Math.min(100, value)) : 50) + '%');
      }
      const requested = data.src;
      photo.dataset.gvExpected = requested;
      photo.alt = data.alt;
      photo.onload = () => {
        if (photo.dataset.gvExpected !== requested) return;
        photoReady = true;
        photo.hidden = false;
        photoMissing.hidden = true;
        zoomBtn.disabled = false;
      };
      photo.onerror = () => {
        if (photo.dataset.gvExpected !== requested) return;
        photoReady = false;
        photo.hidden = true;
        photoMissing.hidden = false;
        zoomBtn.disabled = true;
      };
      photo.src = requested;
      if (photo.complete && photo.naturalWidth > 0) photo.onload();
      if (dialog.open) renderDialog();
    }
    function move(delta) {
      index = Math.max(0, Math.min(currentPhotos().length - 1, index + delta));
      renderPhoto();
    }
    function renderDialog() {
      const data = currentPhotos()[index];
      if (!data) return;
      dialogImg.src = data.src;
      dialogImg.alt = data.alt;
      el('dialog-prev').hidden = index <= 0;
      el('dialog-next').hidden = index >= currentPhotos().length - 1;
    }
    function choose(type) {
      if (!variants[type] || !variants[type].available) return;
      selected = type;
      index = 0;
      voucher.querySelectorAll('[data-gv-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gvChoice === type)));
      const digital = type === 'digital';
      el('kicker').textContent = digital ? 'Online dárkový poukaz' : 'Tištěný dárkový poukaz';
      el('title').textContent = digital ? 'K předání online' : 'K předání do ruky';
      el('lead').textContent = digital ? 'PDF můžete vytisknout nebo přeposlat.' : 'Prémiový poukaz s matnou laminací v pevné černé obálce. Připravený rovnou k předání.';
      el('delivery-label').textContent = digital ? 'Doručení e-mailem' : 'Odesíláme';
      el('delivery-title').textContent = digital ? 'Do ' + (voucher.dataset.gvDelivery || 'jedné minuty') + ' od zaplacení' : 'Následující den';
      el('delivery-desc').textContent = digital ? 'PDF poukaz i herní kód dorazí na váš e-mail.' : 'Doručovací adresu zadáte při dokončení objednávky.';
      nameWrap.hidden = !digital;
      el('protection').hidden = digital;
      el('code-note').hidden = digital;
      el('price-label').textContent = digital ? 'Online poukaz' : 'Tištěný poukaz';
      el('price').textContent = variants[type].price;
      setPurchase(!panel.hidden);
      syncBuyButtons();
      errorMessage('');
      renderPhoto();
    }
    function positionPanel() {
      if (!grid) return;
      const cards = [...grid.querySelectorAll(':scope > [data-lgv-card-cell]')];
      const cardIndex = cards.indexOf(row.closest('[data-lgv-card-cell]'));
      if (cardIndex < 0) return;
      const columns = getComputedStyle(grid).gridTemplateColumns.trim().split(/\s+/).length;
      const last = Math.min(cards.length - 1, Math.floor(cardIndex / columns) * columns + columns - 1);
      if (cards[last].nextElementSibling !== slot) cards[last].after(slot);
    }
    voucher.btmGiftPosition = positionPanel;
    voucher.btmGiftClose = () => toggle(false);
    function toggle(show) {
      if (show && grid) {
        grid.querySelectorAll('[data-btm-gift]').forEach(other => {
          if (other !== voucher) other.btmGiftClose?.();
        });
        positionPanel();
      }
      if (slot) slot.hidden = !show;
      panel.hidden = !show;
      openBtns.forEach(button => button.setAttribute('aria-expanded', String(show)));
      setPurchase(show);
      if (show) choose(selected);
    }
    openBtns.forEach(button => button.addEventListener('click', () => {
      toggle(context === 'product' && button !== openBtn ? true : panel.hidden);
      if (!panel.hidden) {
        panel.scrollIntoView({block:context === 'home' ? 'nearest' : 'start', behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
    }));
    el('close').addEventListener('click', () => { toggle(false); openBtn.focus(); });
    voucher.querySelectorAll('[data-gv-choice]').forEach(button => button.addEventListener('click', () => choose(button.dataset.gvChoice)));
    el('prev').addEventListener('click', () => move(-1));
    el('next').addEventListener('click', () => move(1));
    zoomBtn.addEventListener('click', () => {
      if (!photoReady || typeof dialog.showModal !== 'function') return;
      renderDialog();
      dialog.showModal();
      el('dialog-close').focus();
    });
    el('dialog-close').addEventListener('click', () => dialog.close());
    el('dialog-prev').addEventListener('click', () => move(-1));
    el('dialog-next').addEventListener('click', () => move(1));
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
    });
    let busy = false;
    function syncBuyButtons() {
      directBtns.forEach(button => { button.disabled = busy || !variants.digital?.available; });
      openBtns.forEach(button => { button.disabled = busy || (!variants.digital?.available && !variants.printed?.available); });
      add.disabled = busy || !variants[selected]?.available;
    }
    directBtns.forEach(button => button.addEventListener('click', () => setPurchase(false)));
    add.addEventListener('click', () => setPurchase(true));
    recipient.addEventListener('keydown', event => {
      if (event.key === 'Enter' && !event.isComposing) {
        event.preventDefault();
        if (!busy) form.requestSubmit(add);
      }
    });
    form.addEventListener('submit', async event => {
      const asGift = event.submitter === add || (!event.submitter && !panel.hidden);
      if (busy) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      if (!setPurchase(asGift)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        errorMessage('Vybraná varianta momentálně není dostupná.');
        return;
      }
      // A single form handles ordinary purchases and both gift types in every context.
      event.preventDefault();
      event.stopImmediatePropagation();
      if (asGift && selected === 'digital') {
        recipient.value = recipient.value.trim();
        if (!recipient.value) {
          errorMessage('Vyplňte jméno obdarovaného pro online poukaz.');
          recipient.focus();
          recipient.reportValidity();
          return;
        }
      }
      errorMessage('');
      busy = true;
      form.setAttribute('aria-busy', 'true');
      syncBuyButtons();
      const routeRoot = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error(typeof result.description === 'string'
            ? result.description
            : 'Produkt se nepodařilo přidat do košíku.');
        }
        window.location.assign(routeRoot + 'cart');
      } catch (exc) {
        busy = false;
        form.removeAttribute('aria-busy');
        syncBuyButtons();
        if (!asGift) toggle(true);
        errorMessage(exc.message || 'Přidání do košíku se nepodařilo.');
      }
    }, true);
    voucher.btmGiftReset = () => {
      busy = false;
      form.removeAttribute('aria-busy');
      setPurchase(!panel.hidden);
      syncBuyButtons();
    };
    if (variants.digital) {
      priceNodes.forEach(node => { node.textContent = variants.digital.price; });
      row.querySelectorAll('[data-pgv-compare]').forEach(node => { node.textContent = variants.digital.compare || ''; node.hidden = !variants.digital.compare; });
    }
    setPurchase(false);
    choose(selected);
    const params = new URLSearchParams(window.location.search);
    const printedLink = variants.printed?.available && params.get('variant') === variants.printed.id;
    if (context === 'product' && (printedLink || params.get('darek') === '1' || params.get('gift') === '1')) {
      if (printedLink) choose('printed');
      else if (variants.digital?.available) choose('digital');
      toggle(true);
    }
    syncBuyButtons();
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-btm-gift]')) activate(scope);
    scope.querySelectorAll('[data-btm-gift]').forEach(activate);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-lgv-slot]:not([hidden]) [data-btm-gift]').forEach(voucher => voucher.btmGiftPosition?.());
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-btm-gift]').forEach(voucher => voucher.btmGiftReset?.());
  });
})();

